module.exports = __webpack_public_path__ + "static/media/marketing-3-empty.63faace1.png";